'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateEntry = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _keyPaths = require('../constants/keyPaths');

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _operatorInvariant = require('../invariants/operatorInvariant');

var _applyIdInvariant = require('./applyIdInvariant');

var _applyIdTransform = require('./applyIdTransform');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Update an entry in IndexedAsyncData
 *
 * @param {Any} id an id that passes the id invariant
 * @param {Function} operator operator to apply to data receives `data` as argument
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to update the entry in
 * @returns {IndexedAsyncData}
 */
var updateEntry = exports.updateEntry = (0, _curry2.default)(function (id, operator, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);
  (0, _operatorInvariant.operatorInvariant)(operator);
  (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

  var key = (0, _applyIdTransform.applyIdTransform)(id, indexedData);
  return indexedData.updateIn(_keyPaths.ENTRIES, function (entries) {
    return entries.update(key, (0, _getters.getNotSetValue)(indexedData), operator);
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/operators/updateEntry.js
// module id = 891
// module chunks = 2 3